<template>
    <div class="modal fade" id="BookingModal" tabindex="-1" role="dialog" aria-labelledby="BookingModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="BookingModalLabel">Nouvelle ligne de réservation</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">


                    <div class="row" v-show="!form.article">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="lot">Lot</label>
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="lotSearchInput" type="text" v-model="form.lot">
                            </div>
                            
                        </div>
                    </div>

                    <div class="row" v-show="!form.lot">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="article">Article</label>
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="articleSearchInput" type="text" v-model="form.article">
                            </div>
                        </div>
                    </div>

                  
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="resetForm()">Annuler</button>
                    <button type="button" class="btn btn-success" @click="saveBooking" :disabled="isFormValid() == false">Enregistrer</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    props: ['lots', 'articleUrl', 'booking', 'storeBookingLineUrl', 'lotUrl', 'orderId'],
    data() {
        return {
            form: {
                article: null,
                lot: null,
                booked_start_date: '',
                booked_quantity: 1,
                booking_id: null,
                lot_id: null,
                article_id: null
            },
        }
    },
   
    methods: {
        isFormValid() {
            if(this.form.lot && this.form.lot != null)
                return this.form.lot != null
            else 
                return this.form.article_id != null;
        },
        saveBooking() {
            const data = {
                article_id: this.form.article_id,
                booked_quantity: this.form.booked_quantity,
                booked_start_date: this.form.booked_start_date,
                booking_id: this.booking.id,
                lot_id: this.form.lot_id ? this.form.lot_id : null,
                order_id : this.orderId
            };

           fetch(this.storeBookingLineUrl, {
                method: 'POST',
                headers: this.getHttpJsonRequestHeaders().headers,
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    $('#BookingModal').modal('hide');
                    this.resetForm();
                    this.$emit('booking-saved');
                } else {
                    console.error('Erreur lors de l\'enregistrement:', data.message);
                }
            })
            .catch(error => {
                console.error('Erreur lors de l\'enregistrement:', error);
            });
        },
        resetForm() {
            this.form.article = null;
            this.form.article_id = null;
            this.form.booking_id = null;
            this.form.lot_id = null;
            this.form.lot = null;
            this.form.booked_start_date = '';
            this.form.booked_quantity = 1;
        }
    },
    mounted() {
        this.lotsData = this.lots;
        console.log(this.storeBookingLineUrl)

        $('#startBookingDate').datepicker({
            format: "dd/mm/yyyy",
            todayBtn: true,
            language: "fr",
            calendarWeeks: true,
            autoclose: true,
            todayHighlight: true,
            clearBtn: false,
            startDate: new Date()
        }).on('changeDate', (e) => {
            this.form.booked_start_date = e.format('dd/mm/yyyy');
        });

        $("#articleSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.articleUrl,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term,},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.form.article = null
                        this.form.article_id = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.form.article = item.item.name,
                        this.form.article_id = item.item.id
                        console.log(this.form);
                    }
                }
            }).focus(() => {
                $("#articleSearchInput").autocomplete("search", '');
        });


        $("#lotSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.lotUrl,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, booking : 1, order_id: this.orderId},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.form.lot = null
                        this.form.lot_id = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.form.lot = item.item.name,
                        this.form.lot_id = item.item.id
                    }
                }
            }).focus(() => {
                $("#lotSearchInput").autocomplete("search", '');
        });
    }

}
</script> 